import Vue from "vue"
import Vuex from "vuex"
Vue.use(Vuex)

const getDefaultState = () => {
  return {
    ressources: new Map(),
  }
}

const state = getDefaultState()

const getters = {
  ressources: (state) => {
    return state.ressources
  },
}

const mutations = {
  SET_RESSOURCES(state, ressources) {
    state.ressources = new Map(
      ressources.map((ressource) => {
        return [ressource.code, ressource]
      })
    )
  },
  ADD_RESSOURCES(state, ressources) {
    const merged = new Map(state.ressources)
    ressources.forEach((ressource) => merged.set(ressource.code, ressource))
    state.ressources = merged
  },
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
}
